export default __webpack_public_path__ + "static/media/acm_factor_blur_text.8af04b96.png";